import {
  pageMoveAnkerFunc,
} from "./common/_pageLinkAnimation";
import {
  fadeInFunc
} from "./common/_common";
import {
	heightLine,
	heightLineSetFunc,
	heightLineFunc,
} from "./common/_heightLine";
import {
  idxFunc,
} from "./pages/_index";

import { animation } from "./pages/_animation";
//* ---------------------------------------
//通常実行
//-------------------------------------- */
let setTimer = false;
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
  pageMoveAnkerFunc();
  fadeInFunc();
  
  idxFunc();

  //高さ調整
  heightLine();
  heightLineSetFunc();
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  //高さ調整
  let heightAdjustment = function(){
    heightLine();
    heightLineFunc();
  }
  setTimeout(heightAdjustment, 300);
  
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    //処理
  }, 200);
});